export const getDriverName = (driver: Record<string, unknown>): string => {
  const firstName = (driver.first_name ?? driver.firstName ?? driver.name ?? "") as string;
  const lastName = (driver.last_name ?? driver.lastName ?? driver.surname ?? "") as string;
  const combined = `${firstName} ${lastName}`.trim();
  if (combined) return combined;
  return (driver.full_name as string) ?? (driver.displayName as string) ?? (driver.nickname as string) ?? "Motorista";
};
